// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import axios from 'axios'
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueTouch from 'vue-touch';
import Trend from 'vuetrend';
import Toasted from 'vue-toasted';
import VueApexCharts from 'vue-apexcharts';
import Notifications from 'vue-notification';

// register vue-country-flag component
import CountryFlag from 'vue-country-flag'
Vue.component('country-flag', CountryFlag)

// register vue-search component
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css';


import store from './store';
import router from './Routes';
import App from './App';

// Importamos por defecto el token en la cabecera de las peticiones
axios.defaults.headers.common['Authorization'] = 'JWT ' + localStorage.getItem('t');

Vue.use(BootstrapVue);
Vue.use(Notifications);
Vue.use(VueTouch);
Vue.use(Trend);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyB7OXmzfQYua_1LEhRdqsoYzyJOPh9hGLg',
  },
});
Vue.use(Toasted, { duration: 10000 });
Vue.component('apexchart', VueApexCharts);
// MomentJs para cambiar el formato de las fechas
Vue.use(require('vue-moment'));

import Fragment from 'vue-fragment'
Vue.use(Fragment.Plugin)

/* --------------------------- Directiva Personalizada para centrar un elemento -------------------------  */

Vue.directive('center', {
  bind: (el) => {
    el.classList.add('d-flex', 'justify-content-center', 'align-items-center', 'p-4');
  }
});

Vue.directive('fullViewPort', {
  bind: (el) => {
    el.style.heigth = '100vh';
    el.style.width = '100vw';
  }
});

/* ------------------------------------------------------------------------------------------------------  */

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App),
});
